import { useTranslation } from 'react-i18next';
import InfoIcon from 'components/atoms/icons/infoIcon';
import { useState } from 'react';

import s from './styles.module.scss';
import RecoveredStatusModal from './modal';

import type { FC } from 'react';

interface RecoveredStatusProps {
  recoveredByReadingId?: string;
  patientGuid: string;
}

const RecoveredStatus: FC<RecoveredStatusProps> = ({
  recoveredByReadingId,
  patientGuid,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        className={s['recovered-wrapper']}
        data-sub-status
        disabled={!recoveredByReadingId}
        onClick={() => setIsModalOpen(true)}
      >
        <div className={s['recovered-text']}>
          {t('overviewDashboard.recovered')}
        </div>
        <div className={s['recovered-info-button']}>
          <InfoIcon height="14px" width="14px" />
        </div>
      </button>
      {recoveredByReadingId && isModalOpen && (
        <RecoveredStatusModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
          }}
          patientGuid={patientGuid}
          recoveredByReadingId={recoveredByReadingId}
        />
      )}
    </>
  );
};
export default RecoveredStatus;
